import { MemberDto, PermissionDto } from '@careapp-group/ng-sdk';
import { CustomerTeam, Members } from '../actions/index';
import { ORGANISATION_CONTEXT_SWITCH } from '../actions/meta.actions';
import { DataListState } from '../data-list.state';
import { ReducerStateFactory } from '../state-factory.reducer';

class CustomerTeamReducer extends ReducerStateFactory<MemberDto> {
  constructor() {
    super(CustomerTeam);
  }

  reducer(
    state: DataListState<MemberDto> = this.initialState,
    action: any
  ): DataListState<MemberDto> {
    switch (action.type) {
      case ORGANISATION_CONTEXT_SWITCH:
        return { ...state, entities: {}, ids: [], selectedId: null };
      case CustomerTeam.ResponseSuccessRemove.type: {
        const ids = Array.from(new Set(state.ids.filter((value) => value != action.memberId)));
        const entities = ids.reduce(
          (prev, next) => ({ ...prev, [next]: state.entities[next] }),
          {}
        );
        return {
          ...state,
          loadingAll: false,
          ids,
          entities,
        };
      }
      case CustomerTeam.RequestCreateForCustomerAction.type: {
        return { ...state, creating: true };
      }
      case CustomerTeam.ResponseSuccessAddMemberToCustomer.type: {
        return { ...state, creating: false };
      }
      case Members.ResponseSuccessUpdatePermission.type: {
        const permission: PermissionDto = action.permission;
        if (permission.modelName !== 'Customer') {
          return state;
        }
        if (!state.entities[permission.memberId]) {
          return state;
        }
        return {
          ...state,
          entities: {
            ...state.entities,
            [permission.memberId]: {
              ...state.entities[permission.memberId],
              permissions: [
                ...state.entities[permission.memberId].permissions.filter(
                  (p) => p.id !== permission.id
                ),
                permission,
              ],
            },
          },
        };
      }
    }
    return super.reducer(state, action);
  }
}

export const state = new CustomerTeamReducer();

export function reducer(...args) {
  return state.reducer.apply(state, args);
}
